const route = {
	name: 'new-evaluation',
	path: 'new-evaluation',
	component: () => import('@/modules/three-sixty-evaluation/pages/page-three-sixty-evaluation'),
	meta: {
		title: 'Evaluación 360',
	},
	props: true,
	redirect: '/new-evaluation/new',
	children: [
		{
			name: 'new-three-sixty-evaluation',
			path: 'new',
			component: () =>
				import('@/modules/three-sixty-evaluation/pages/page-new-three-sixty-evaluation'),
		},
		{
			path: '*',
			redirect: '/new-evaluation',
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/router/index.js